/* src/app/delivery-defense/delivery-defense-subscription-renew-dialog/delivery-defense-subscription-renew-dialog.component.scss */
.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  z-index: 99;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  min-height: 36.8125rem;
  padding: 3.63rem 3.5rem;
  position: relative;
  z-index: 0;
  overflow: auto;
  background-color: #F8FBFB;
}
.dialog-content.regular .gradient-background {
  --top-gap: 12rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: url(/assets/images/dd-subscription-renew-dailog-background.svg) no-repeat;
  background-size: contain;
  background-position-y: var(--top-gap);
}
.dialog-content.regular .gradient-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: var(--top-gap);
  z-index: -2;
  background-color: #F3F3F3;
}
@media screen and (min-width: 48rem) {
  .dialog-content.regular .gradient-background {
    background-position-y: 0;
  }
  .dialog-content.regular .gradient-background::before {
    background-color: transparent;
  }
}
.dialog-content.regular .title {
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.5rem;
  text-align: center;
}
@media screen and (min-width: 48rem) {
  .dialog-content.regular .title {
    line-height: 4.0625rem;
  }
}
.dialog-content.regular .credit-details {
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3.5rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content.regular .credit-details {
    line-height: 2.5rem;
  }
}
.dialog-content.regular .price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  row-gap: 1rem;
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 4.0625rem;
  margin-bottom: 1rem;
}
.dialog-content.regular .price::after {
  content: "";
  display: flex;
  width: 7.125rem;
  height: 0.25rem;
  background-color: #004791;
}
.dialog-content.regular .charge-details {
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  padding: 0.5rem 0;
}
@media screen and (min-width: 48rem) {
  .dialog-content.regular .charge-details {
    padding: 1rem 4.25rem;
  }
}
.dialog-content.regular .condition {
  color: #5F5753;
  font-size: 0.5625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.9375rem;
  padding: 1.5rem 2rem 0 2rem;
}
.dialog-content.regular .agree {
  color: #5F5753;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  padding: 0 2rem;
  width: 100%;
}
.dialog-content.regular .agree a {
  text-decoration: underline;
}
.dialog-content.complimentary {
  padding: 2.26rem 3.63rem 2.92rem;
}
.dialog-content.complimentary .title {
  font-size: 2.0625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 3.875rem;
}
.dialog-content.complimentary .logo {
  padding: 1.56rem 0;
}
.dialog-content.complimentary .message {
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  text-align: center;
  margin-bottom: 2.19rem;
}
.dialog-content.complimentary .condition {
  font-size: 0.6875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.9375rem;
}
.dialog-content.complimentary .agree {
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 2.19rem;
  width: 100%;
}
.dialog-content.form {
  padding: 0 0 2.19rem 0;
}
.dialog-content.form .introduction {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1.69rem 3.38rem 1.75rem;
  background-color: #E7F2F2;
}
.dialog-content.form .title {
  font-size: 2.0625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 3.875rem;
}
.dialog-content.form .credit-details {
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
}
.dialog-content.form form {
  padding: 1.88rem 3.5rem 0;
  margin: 0 auto;
}
@media screen and (min-width: 48rem) {
  .dialog-content.form form {
    padding: 1.88rem 6.5rem 0;
  }
}
.dialog-content.form form .inputs {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 2.5rem;
  row-gap: 1.25rem;
  padding-bottom: 0.75rem;
}
.dialog-content.form form .inputs .mat-mdc-form-field {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dialog-content.form form .inputs .mat-mdc-form-field.half-width {
    max-width: 45.35%;
  }
}
.dialog-content.upgrade,
.dialog-content.downgrade {
  padding-bottom: 2rem;
}
.dialog-content.upgrade .dialog-header,
.dialog-content.downgrade .dialog-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dialog-content.upgrade .dialog-header,
  .dialog-content.downgrade .dialog-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    justify-content: space-between;
  }
}
.dialog-content.upgrade .dialog-header img,
.dialog-content.downgrade .dialog-header img {
  width: 11.22756rem;
  height: 4.0625rem;
}
.dialog-content.upgrade .dialog-header .remark,
.dialog-content.downgrade .dialog-header .remark {
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  align-self: flex-end;
  padding: 1rem 0;
}
.dialog-content.upgrade .title,
.dialog-content.downgrade .title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 2rem 0;
  font-size: 2.0625rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.5rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content.upgrade .title,
  .dialog-content.downgrade .title {
    padding: 4rem 0 2.81rem 0;
  }
}
.dialog-content.upgrade .message,
.dialog-content.downgrade .message {
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  margin-bottom: 2rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content.upgrade .message,
  .dialog-content.downgrade .message {
    margin-bottom: 4rem;
  }
}
.dialog-content .actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1.5rem;
  padding: 3rem 0 0;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dialog-content .actions {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    justify-content: center;
  }
}
.dialog-content .actions:last-child {
  padding: 0;
}
.dialog-content .actions:last-child button {
  width: 15.625rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}
.dialog-content .actions:last-child button:only-child {
  width: 12.5rem;
}
.dialog-content .actions button {
  min-width: 10.63333rem;
  padding: 1.25rem;
}
.dialog-content .actions button:only-child {
  margin: 0 auto;
}
button.tab-trap {
  width: 0;
  height: 0;
  position: absolute;
  left: -9999px;
}
:host(.delivery-defense-subscription-renew-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  position: relative;
}
/*# sourceMappingURL=delivery-defense-subscription-renew-dialog.component.css.map */
